export const PLANNING_SETTINGS_COPY = {
  tabsLabel: "Planning settings",
  title: "Planning",
  generalTab: "General",
  agentTab: "Agent",
  automationTab: "Automation",
  planningLabel: "Planning",
  planningHelper: "An agent starts a planning session for each task that enters Backlog, to raise the success rate.",
  checksLabel: "Planning checks",
  checksHelper: "What the agent checks in each planning session.",
  checksOffHelper: "Turn Planning on to use these checks.",
  confidenceLabel: "Confidence estimate",
  confidenceHelper: "The agent checks if one run can finish the task and offers to split work that is too big.",
  clarityLabel: "Clarity check",
  clarityHelper: "The agent grades how clear the request is and keeps asking until the gaps are closed.",
  healthLabel: "Health",
  healthReady: "Ready",
  healthDisabled: "Off",
  healthReadyHelper: "An agent plans each task that enters Backlog.",
  healthDisabledHelper: "Tasks wait in Backlog as written. Nobody plans them.",
  save: "Save",
  saving: "Saving",
  saveError: "Could not save Planning settings.",
  loading: "Loading Planning settings.",
  loadError: "Could not load Planning settings.",
  retry: "Retry",
  automationEmpty: "This automation has no steps yet.",
  automationLoading: "Loading the steps.",
  automationError: "Could not load the steps.",
  wizardPageTitle: "How should new backlog tasks be refined?",
  wizardStepRefine: "How should new backlog tasks be refined?",
  wizardRefineOption: "Refine with a plan",
  wizardRefineHelper:
    "An agent starts a planning session for each task that enters Backlog, to raise the success rate.",
  wizardSourceOption: "Keep the source description",
  wizardSourceHelper: "Nothing runs in Backlog. Tasks wait as written until someone starts them.",
  wizardStepConfidence: "Should the agent estimate confidence?",
  wizardStepClarity: "Should the agent check clarity?",
  wizardConfidenceOnOption: "Estimate confidence",
  wizardConfidenceOnHelper:
    "During planning, the agent checks if one run can finish the task and offers to split work that is too big.",
  wizardConfidenceOffOption: "Skip the confidence estimate",
  wizardConfidenceOffHelper: "The agent plans the task as written. Nobody checks if it fits in one run.",
  wizardClarityOnOption: "Check clarity",
  wizardClarityOnHelper:
    "During planning, the agent grades how clear the request is and keeps asking until the gaps are closed.",
  wizardClarityOffOption: "Skip the clarity check",
  wizardClarityOffHelper: "The agent plans with the details it has. Nobody checks for gaps before the run.",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardBackToBoard: "Back to board",
  wizardBack: "Back",
  wizardPreviewLabel: "Example draft task",
  wizardPreviewDraftTitle: "Add dark mode",
  wizardPreviewSource: "Source",
  wizardPreviewSourceName: "GitHub",
  wizardPreviewIssue: "Issue #184",
  wizardPreviewArtifacts: "Artifacts",
  wizardPreviewArtifactsNone: "None yet",
  wizardPreviewChat: "Chat",
  wizardPreviewPlan: "Plan",
  wizardPreviewStart: "Start",
  wizardPreviewReady: "This task is ready to start",
  wizardPreviewCautionHeadline: "Review before you start",
  wizardPreviewCautionText: "Start if you accept the risk, or split the work.",
  wizardPreviewUserMessage: "Add a dark mode toggle in Settings.",
  wizardPreviewAgentMessage: "I reviewed the request and wrote a plan.",
  wizardPreviewAgentQuestion: "Follow the system theme by default?",
  wizardPreviewOptionOne: "Yes, follow system",
  wizardPreviewOptionTwo: "No, start light",
  wizardPreviewConfidenceMessage: "This task is too big for one run. It changes every screen.",
  wizardPreviewConfidenceQuestion: "Split it into smaller tasks?",
  wizardPreviewConfidenceOptionOne: "Split by area",
  wizardPreviewConfidenceOptionTwo: "Keep one task",
  wizardPreviewClarityMessage: "The plan is ready, but a few details are not clear yet.",
  wizardPreviewClarityQuestion: "Should the theme choice sync across devices?",
  wizardPreviewClarityOptionOne: "Per account",
  wizardPreviewClarityOptionTwo: "Per device",
  wizardPreviewPlanSteps: [
    "Add a theme toggle to the Settings page.",
    "Save the choice in user preferences.",
    "Apply the saved theme when the app loads.",
  ],
  wizardPreviewSourceBody: "Users ask for a dark theme. Add a toggle in Settings so people can switch.",
  wizardPreviewClarityName: "Clarity",
  wizardPreviewConfidenceName: "Confidence",
  wizardPreviewClaritySummary: "The default theme is defined. Where the choice is saved is not.",
  wizardPreviewConfidenceSummary: "The task changes every screen. Split it by area.",
  wizardPreviewRefineCaption: "The agent reviews the request, writes a plan, and asks a question.",
  wizardPreviewSourceCaption: "The draft shows the source description.",
  wizardPreviewConfidenceOn: "The agent rates how likely one run completes the task and flags risk.",
  wizardPreviewConfidenceOff: "The draft has no Confidence score.",
  wizardPreviewClarityOn: "The agent grades clarity and keeps asking until the gaps are closed.",
  wizardPreviewClarityOff: "The agent plans with the details it has.",
  wizardFinishError: "Could not save Planning settings.",
} as const;
